import truncate from './truncate';
import zipcodeMask from './zipcodeMask';

const locationText = ({
  zipCode = '',
  zipCodeCity = '',
  zipCodeState = '',
  maxCityLength = 24,
  formatter = (city, state) => `${city.toUpperCase()}, ${state.toUpperCase()}`,
  includeAddress = true
} = {}) => {
  const city = zipCodeCity && typeof zipCodeCity === 'string' ? truncate(maxCityLength, zipCodeCity) : '';
  const state = zipCodeState && typeof zipCodeState === 'string' ? zipCodeState : '';
  const zipcode = zipCode && typeof zipCode === 'string' ? zipCode : '';
  const textLocation = formatter(city, state);
  return includeAddress ? `${textLocation} - ${zipcodeMask(zipcode)}` : zipcodeMask(zipcode);
};

export default locationText;